// This file was generated by `web_api_types::point_registry` from `ss_well_ontology::geo`. Do not edit this file manually.
import type { CrsFamily } from "./CrsFamily";
import type { DatumId } from "./DatumId";

/** Датумы реестра в порядке реестра (`DatumId::all()`) — порядок пунктов выпадающего списка. */
export const DATUM_IDS: DatumId[] = [
  "Wgs84",
  "Ed50",
  "Pulkovo1942",
  "Ucs2000",
  "Albanian1987",
  "Etrf2000Pl",
  "AinElAbd",
  "Mgi1901Serbia",
  "Ed50Turkey",
];

/** Каноническое имя датума в реестре (`DatumId::name()`). */
export const DATUM_NAMES: Record<DatumId, string> = {
  Wgs84: "WGS84",
  Ed50: "ED50",
  Pulkovo1942: "Pulkovo 1942",
  Ucs2000: "UCS-2000",
  Albanian1987: "Albanian 1987",
  Etrf2000Pl: "ETRF2000-PL",
  AinElAbd: "Ain el Abd 1970",
  Mgi1901Serbia: "MGI 1901 (Serbia)",
  Ed50Turkey: "ED50 (Türkiye)",
};

/** Семейства CRS в порядке реестра (`CrsFamily::ALL`) — порядок пунктов выпадающего списка. */
export const CRS_FAMILY_IDS: CrsFamily[] = [
  "UtmWgs84North",
  "UtmWgs84South",
  "Pulkovo1942GkPrefixed",
  "Utm35nEd50",
  "Utm37nEd50Turkey",
  "Utm39nAinElAbd",
  "PolandCs92",
  "Mgi1901BalkansZone7",
  "Albanian1987GkZone4",
];

/** Каноническое имя семейства CRS в реестре (`CrsFamily::name()`) — без номера зоны. */
export const CRS_FAMILY_NAMES: Record<CrsFamily, string> = {
  UtmWgs84North: "WGS84 / UTM (north)",
  UtmWgs84South: "WGS84 / UTM (south)",
  Pulkovo1942GkPrefixed: "Pulkovo 1942 / GK (prefixed easting)",
  Utm35nEd50: "ED50 / UTM zone 35N",
  Utm37nEd50Turkey: "ED50 (Türkiye) / UTM zone 37N",
  Utm39nAinElAbd: "Ain el Abd 1970 / UTM zone 39N",
  PolandCs92: "ETRF2000-PL / CS92",
  Mgi1901BalkansZone7: "MGI 1901 (Serbia) / Balkans zone 7",
  Albanian1987GkZone4: "Albanian 1987 / GK zone 4",
};

/** Шаблон ПОЛНОГО имени объявленной CRS (`CrsId::name()`): на месте номера зоны стоит `{zone}`, у поимённых семейств шаблон — само имя. */
export const CRS_FAMILY_FULL_NAME_TEMPLATES: Record<CrsFamily, string> = {
  UtmWgs84North: "WGS84 / UTM zone {zone}N",
  UtmWgs84South: "WGS84 / UTM zone {zone}S",
  Pulkovo1942GkPrefixed: "Pulkovo 1942 / GK zone {zone} (prefixed easting)",
  Utm35nEd50: "ED50 / UTM zone 35N",
  Utm37nEd50Turkey: "ED50 (Türkiye) / UTM zone 37N",
  Utm39nAinElAbd: "Ain el Abd 1970 / UTM zone 39N",
  PolandCs92: "ETRF2000-PL / CS92",
  Mgi1901BalkansZone7: "MGI 1901 (Serbia) / Balkans zone 7",
  Albanian1987GkZone4: "Albanian 1987 / GK zone 4",
};

/** Параметризовано ли семейство номером зоны (`CrsFamily::needs_zone()`): зона задана ТОГДА И ТОЛЬКО ТОГДА, когда семейство ею параметризовано. */
export const CRS_FAMILY_NEEDS_ZONE: Record<CrsFamily, boolean> = {
  UtmWgs84North: true,
  UtmWgs84South: true,
  Pulkovo1942GkPrefixed: true,
  Utm35nEd50: false,
  Utm37nEd50Turkey: false,
  Utm39nAinElAbd: false,
  PolandCs92: false,
  Mgi1901BalkansZone7: false,
  Albanian1987GkZone4: false,
};
